export function onClientEntry(): void {
  console.log("%cDesigned by BOND", "font-weight: bold");
}
